module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "update-alert"
    }
  }, [_c('a', {
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Nouvelle version de l'application disponible. Cliquez ici pour la télécharger.")])]), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "light": "",
      "overflow": "",
      "absolute": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("dashboard")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(_vm.tabletName) ? _c('span', [_vm._v(_vm._s(_vm.tabletName))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = false;
        _vm.connectionDialog = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("tablet_android")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [(!_vm.tabletId || !_vm.token || _vm.authenticated === false) ? _c('span', [_vm._v(" Tablette non authentifiée")]) : _c('span', [_vm._v("Tablette authentifiée")])])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.update($event)
      }
    }
  }, [_c('v-list-tile-action', [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_c('v-icon', [_vm._v("warning")])], 1) : (_vm.isUpdating) ? _c('span', {
    staticClass: "loading-rotate"
  }, [_c('v-icon', [_vm._v("cached")])], 1) : _c('span', [_c('v-icon', [_vm._v("check_circle")])], 1)]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Status:\n            "), (_vm.online) ? _c('strong', [_vm._v("connecté")]) : _c('strong', [_vm._v("hors connexion")])]), _vm._v(" "), _c('v-list-tile-sub-title', [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_vm._v("Mises à jours nécessaires.")]) : (_vm.isUpdating) ? _c('span', [_vm._v("Mise à jour en cours...")]) : (_vm.online) ? _c('span', [_vm._v("Données à jour")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleShowMoreInMenu()
      }
    }
  }, [_c('v-list-tile-content', [(_vm.showMoreInMenu) ? _c('v-list-tile-title', [_vm._v("Réduire")]) : _c('v-list-tile-title', [_vm._v("Avancé")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.showMoreInMenu) ? _c('v-icon', [_vm._v("keyboard_arrow_up")]) : _c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), (_vm.showMoreInMenu) ? [_c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": !_vm.online
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendDiag()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("bug_report")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Envoyer un rapport\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "disabled": !_vm.online
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadApp()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Rafraichir l'application\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        _vm.goToAdmin()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              Administration\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title')], 1)], 1)] : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0"
    },
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-tile-content', [_vm._v("\n          Version : " + _vm._s(_vm.version) + "\n        ")])], 1)], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "blue top-toolbar",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Weview")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), ((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_vm._v("Mises à jours nécessaires.")]) : (_vm.isUpdating) ? _c('span', [_vm._v("Mise à jour en cours...")]) : (!_vm.online) ? _c('span', [_vm._v("Hors ligne")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.update($event)
      }
    }
  }, [((_vm.stagedAnswers.length > 0 || _vm.dataExpired) && !_vm.isUpdating) ? _c('span', [_c('v-icon', [_vm._v("warning")])], 1) : (_vm.isUpdating) ? _c('span', {
    staticClass: "loading-rotate"
  }, [_c('v-icon', [_vm._v("cached")])], 1) : (!_vm.online) ? _c('span', [_c('v-icon', [_vm._v("remove_circle")])], 1) : _c('span', [_c('v-icon', [_vm._v("check_circle")])], 1)])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "width": "480"
    },
    model: {
      value: (_vm.confirmSendDiag),
      callback: function($$v) {
        _vm.confirmSendDiag = $$v
      },
      expression: "confirmSendDiag"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Envoyer un rapport")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Êtes-vous sûr de vouloir envoyer un rapport aux équipes Weview ?\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (!_vm.isSendingDiag) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.confirmSendDiag = false
      }
    }
  }, [_vm._v("Non")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": "",
      "color": "accent",
      "loading": _vm.isSendingDiag
    },
    nativeOn: {
      "click": function($event) {
        _vm.processSendDiag()
      }
    }
  }, [_vm._v("Envoyer")])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "home pt-4"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [(!_vm.token || !_vm.tabletId || _vm.authenticated === false) ? [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": "true",
      "error": ""
    }
  }, [_vm._v("\n            Cette tablette n'est pas authentifiée\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "primary": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connectionDialog = true
      }
    }
  }, [_vm._v("Connecter la tablette")])] : (_vm.dataExpired) ? _c('div', [_c('v-alert', {
    staticClass: "mb-4",
    attrs: {
      "value": "true",
      "error": ""
    }
  }, [_vm._v("Les données de cette tablette ont expiré. Merci de connecter cette tablette à internet et/ou de retrouver du réseau afin de les mettre à jour")])], 1) : (_vm.dataExpired && _vm.isUpdating) ? _c('div', {
    staticClass: "loading text-xs-center"
  }, [_c('h4', {
    staticClass: "pb-4 pt-4"
  }, [_vm._v("Données en cours de synchronisation...")]), _vm._v(" "), _c('v-progress-circular', {
    staticClass: "primary--text",
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7
    }
  })], 1) : _c('navigation', {
    attrs: {
      "currentMenu": _vm.item
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "width": "480"
    },
    model: {
      value: (_vm.connectionDialog),
      callback: function($$v) {
        _vm.connectionDialog = $$v
      },
      expression: "connectionDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Quel est le code de connexion de cette tablette ?")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Code de connexion"
    },
    model: {
      value: (_vm.connectionCode),
      callback: function($$v) {
        _vm.connectionCode = $$v
      },
      expression: "connectionCode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connectionDialog = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.connect($event)
      }
    }
  }, [_vm._v("Connexion")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bc3f2be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 320
// module chunks = 1